import api from '../api/api'
import { call, put, take } from 'redux-saga/effects'
import { noop } from 'redux-saga/utils'
import { statusCodeIsBelow400, appendToFormData } from '../helpers/utility'

import {
  FETCH_SUPPORT_TICKETS_REQUEST,
  FETCH_SUPPORT_TICKETS_SUCCESS,
  FETCH_SUPPORT_TICKETS_FAILURE,
} from '../actions/actions'

import {
  FETCH_SINGLE_SUPPORT_TICKET_REQUEST,
  FETCH_SINGLE_SUPPORT_TICKET_SUCCESS,
  FETCH_SINGLE_SUPPORT_TICKET_FAILURE,
} from '../actions/actions'

import {
  CREATE_SUPPORT_TICKET_REQUEST,
  CREATE_SUPPORT_TICKET_SUCCESS,
  CREATE_SUPPORT_TICKET_FAILURE,
} from '../actions/actions'

import {
  CREATE_SUPPORT_TICKET_REPLY_REQUEST,
  CREATE_SUPPORT_TICKET_REPLY_SUCCESS,
  CREATE_SUPPORT_TICKET_REPLY_FAILURE,
} from '../actions/actions'

import {
  EDIT_SUPPORT_TICKET_REQUEST,
  EDIT_SUPPORT_TICKET_SUCCESS,
  EDIT_SUPPORT_TICKET_FAILURE,
} from '../actions/actions'

export function* fetchSupportTickets() {
  while (true) {
    const { userType, queryString = '', resolve = noop, reject = noop } = yield take(FETCH_SUPPORT_TICKETS_REQUEST)

    try {
      const {
        data: { data, status, errors }
      } = yield call(api.getSupportTickets, userType, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({ type: FETCH_SUPPORT_TICKETS_SUCCESS, data })
        resolve(data)
      } else {
        yield put({ type: FETCH_SUPPORT_TICKETS_FAILURE, errors })
        reject(errors)
      }
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_SUPPORT_TICKETS_FAILURE, error })
    }
  }
}

export function* fetchSingleSupportTicket() {
  while (true) {
    const {
      userType,
      ticket_code,
      resolve = noop,
      reject = noop
    } = yield take(FETCH_SINGLE_SUPPORT_TICKET_REQUEST)

    try {
      const {
        data: { data, errors, status, }
      } = yield call(api.getSingleSupportTicket, ticket_code, userType)

      if (statusCodeIsBelow400(status)) {
        yield put({ type: FETCH_SINGLE_SUPPORT_TICKET_SUCCESS, data })
        resolve(data.ticket)
      } else {
        yield put({ type: FETCH_SINGLE_SUPPORT_TICKET_FAILURE, errors })
        reject(errors)
      }
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_SINGLE_SUPPORT_TICKET_FAILURE, error })
    }
  }
}

export function* createSupportTicket() {
  while (true) {
    const { formData, resolve = noop, reject = noop } = yield take(CREATE_SUPPORT_TICKET_REQUEST)

    try {
      const {
        data: { data, status, errors }
      } = yield call(api.createSupportTicket, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({ type: CREATE_SUPPORT_TICKET_SUCCESS, data })
        resolve(data)
      } else {
        yield put({ type: CREATE_SUPPORT_TICKET_FAILURE, errors })
        reject(errors)
      }
    } catch (error) {
      console.log(error)
      yield put({ type: CREATE_SUPPORT_TICKET_FAILURE, error })
    }
  }
}

export function* createSupportTicketReply() {
  while (true) {
    const {
      ticketCode,
      formData,
      userType,
      resolve = noop,
      reject = noop
    } = yield take(CREATE_SUPPORT_TICKET_REPLY_REQUEST)

    try {
      const {
        data: { data, status, errors }
      } = yield call(api.replySupportTicket, ticketCode, formData, userType)

      if (statusCodeIsBelow400(status)) {
        yield put({ type: CREATE_SUPPORT_TICKET_REPLY_SUCCESS, data })
        resolve(data)
      } else {
        yield put({ type: CREATE_SUPPORT_TICKET_REPLY_FAILURE, errors })
        reject(errors)
      }
    } catch (error) {
      console.log(error)
      yield put({ type: CREATE_SUPPORT_TICKET_REPLY_FAILURE, error })
    }
  }
}

export function* editSupportTicket() {
  while (true) {
    const {
      ticketCode,
      formData,
      resolve = noop,
      reject = noop
    } = yield take(EDIT_SUPPORT_TICKET_REQUEST)

    try {
      const {
        data: { data, status, errors }
      } = yield call(api.editSupportTicket, ticketCode, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({ type: EDIT_SUPPORT_TICKET_SUCCESS, data })
        resolve(data)
      } else {
        yield put({ type: EDIT_SUPPORT_TICKET_FAILURE, errors })
        reject(errors)
      }
    } catch (error) {
      console.log(error)
      yield put({ type: EDIT_SUPPORT_TICKET_FAILURE, error })
    }
  }
}


// WEBPACK FOOTER //
// ./src/sagas/supportSaga.js